$(document).ready(function () {
    function handleFooterToggle() {
        if ($(window).width() <= 749) {
            // Hide all footer_link_wrapper divs initially
            $('.footer_link_wrapper').hide();

            // Show the first footer_link_wrapper by default and add active class
            // $('.footer_link_wrapper').first().slideDown();
            // $('.footer-block__heading').first().addClass('active');

            // Attach click event to footer-block__heading
            $('.footer-block__heading').off('click').on('click', function () {
                const $wrapper = $(this).next('.footer_link_wrapper'); // Corresponding wrapper

                // Close other open wrappers and remove active class from their headings
                $('.footer_link_wrapper').not($wrapper).slideUp();
                $('.footer-block__heading').not(this).removeClass('active');

                // Slide down the clicked wrapper and toggle active class
                if (!$wrapper.is(':visible')) {
                    $wrapper.slideDown();
                    $(this).addClass('active');
                } else {
                    $wrapper.slideUp();
                    $(this).removeClass('active');
                }
            });
        } else {
            // Remove inline styles and event bindings on larger screens
            $('.footer_link_wrapper').removeAttr('style');
            $('.footer-block__heading').removeClass('active').off('click');
        }
    }

    // Run on page load
    handleFooterToggle();

    // Run on window resize
    $(window).resize(function () {
        // handleFooterToggle();
    });
});

// $(document).ready(function () {
//   function handleFooterToggle() {
//     if ($(window).width() <= 749) {
//       // Set initial state: Collapse all sections
//       $(".footer_link_wrapper").css({ height: 0, overflow: "hidden" });
//       const firstWrapper = $(".footer_link_wrapper").first();
      
//       // Show the first section by animating its height
//       firstWrapper.css({ height: firstWrapper.get(0).scrollHeight, overflow: "hidden" });
//       $(".footer-block__heading").first().addClass("active");

//       // Click event for footer-block__heading
//       $(".footer-block__heading").off("click").on("click", function () {
//         const $wrapper = $(this).next(".footer_link_wrapper");
        
//         // If the clicked section is already open, close it
//         if ($(this).hasClass("active")) {
//           $wrapper.stop().animate({ height: 0 }, 300); // Collapse to height 0
//           $(this).removeClass("active");
//         } else {
//           // Close other sections
//           $(".footer_link_wrapper").stop().animate({ height: 0 }, 300);
//           $(".footer-block__heading").removeClass("active");

//           // Open the clicked section
//           $wrapper.stop().animate({ height: $wrapper.get(0).scrollHeight }, 300); // Expand to scrollHeight
//           $(this).addClass("active");
//         }
//       });
//     } else {
//       // Reset styles and remove click events for larger screens
//       $(".footer_link_wrapper").css({ height: "", overflow: "" });
//       $(".footer-block__heading").removeClass("active").off("click");
//     }
//   }

//   // Run on page load
//   handleFooterToggle();

//   // Run on window resize
//   $(window).resize(function () {
//     // handleFooterToggle();
//   });
// });



